import * as urlUtils from '../../../utils/urlUtils';


export const NAV_PAYMENT_BASE = '/payment';

export const NAV_CUSTOMER_ONBOARD_COMPLETE = `${NAV_PAYMENT_BASE}/customer/onboard/complete/:providerId`;

export const NAV_CUSTOMER_ONBOARD_START = `${NAV_PAYMENT_BASE}/customer/onboard/start/:providerId`;


export const PAYMENT_PROVIDER_ID_STRIPE = 'stripe';


export const PAYMENT_PROVIDER_IDS = [
    PAYMENT_PROVIDER_ID_STRIPE
];


// convenience
export const NAV_CUSTOMER_ONBOARDING_START_STRIPE = urlUtils.buildPath(
    NAV_CUSTOMER_ONBOARD_START, {
        providerId: PAYMENT_PROVIDER_ID_STRIPE
    }
);



export const PAYMENT_ONBOARDING_STATUS_COMPLETE = 'complete';
export const PAYMENT_ONBOARDING_STATUS_ERROR = 'error';
export const PAYMENT_ONBOARDING_STATUS_PENDING = 'pending';
export const PAYMENT_ONBOARDING_STATUS_PROCESS = 'process';

export const PAYMENT_ONBOARDING_STATUSES = [
    PAYMENT_ONBOARDING_STATUS_COMPLETE,
    PAYMENT_ONBOARDING_STATUS_ERROR,
    PAYMENT_ONBOARDING_STATUS_PENDING,
    PAYMENT_ONBOARDING_STATUS_PROCESS
];


export const PAYMENT_STATUS_CLOSED = 'closed';
export const PAYMENT_STATUS_ERROR = 'error';


export const REDIRECT_STATUS_SUCCESS = 'succeeded';
